var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../interface/IVueDialog";
import CommonService from "../../api/CommonService";
import { ESendCodeType } from "../../enum/ESendCodeType";
import RegexStr from "../../common/RegexStr";
var phoneRegex = new RegExp(RegexStr.mobile);
var Password = (function (_super) {
    __extends(Password, _super);
    function Password() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = {
            phone: '',
            code: '',
            pwd: '',
            confirm_pwd: ''
        };
        _this.isValid = false;
        _this.canGetCode = true;
        _this.remainTime = 60;
        _this.timer = null;
        return _this;
    }
    Password.prototype.mounted = function () {
        this.service = CommonService.getInstance();
        if (this.isChangePwd) {
            this.$refs.form.style.height = '190px';
            this.formData.phone = this.phone;
        }
    };
    Password.prototype.close = function () {
        this.$closeDialog();
    };
    Password.prototype.filterPhone = function () {
        this.formData.phone = this.formData.phone.replace(/[^0-9]/g, '');
        if (this.formData.phone.length > 11) {
            this.formData.phone = this.formData.phone.substring(0, 11);
        }
    };
    Password.prototype.filterPassword = function () {
        this.formData.pwd = this.formData.pwd.replace(/\s/g, '');
    };
    Password.prototype.filterConfirmPassword = function () {
        this.formData.confirm_pwd = this.formData.confirm_pwd.replace(/\s/g, '');
    };
    Password.prototype.sendCode = function () {
        var _this = this;
        if (this.timer)
            return;
        if (!phoneRegex.test(this.formData.phone)) {
            this.$message.error('手机号格式不正确！');
            return;
        }
        this.service.sendCode({ phone: this.formData.phone, type: ESendCodeType.changepwd }).then(function (res) {
            _this.$message.success('发送成功！');
        }, function (error) {
            _this.$message.error(error.message);
        });
        this.canGetCode = false;
        this.isValid = false;
        this.timer = setInterval(function () {
            _this.remainTime--;
            if (_this.remainTime === 0) {
                _this.clearTimer();
            }
        }, 1000);
    };
    Password.prototype.clearTimer = function () {
        clearInterval(this.timer);
        this.timer = null;
        this.remainTime = 60;
        this.canGetCode = true;
    };
    Password.prototype.validateCode = function () {
        var _this = this;
        this.formData.code = this.formData.code.replace(/[^0-9]/g, '');
        if (this.formData.code.length > 6) {
            this.formData.code = this.formData.code.slice(0, 6);
        }
        if (this.formData.code.length === 6) {
            this.service.verifyCode({ phone: this.formData.phone, sms_code: this.formData.code }).then(function (res) {
                _this.isValid = true;
                _this.clearTimer();
            }, function (error) {
                _this.$message.error(error.message);
            });
        }
    };
    Password.prototype.save = function () {
        var _this = this;
        this.$validator.validateScopes().then(function (res) {
            if (res) {
                _this.saveAction();
            }
        });
    };
    Password.prototype.saveAction = function () {
        var _this = this;
        this.service.changePwd({
            password: this.formData.pwd,
            phone: this.formData.phone,
            sms_code: this.formData.code
        }).then(function (res) {
            _this.$message.success('修改成功！');
            _this.close();
        }, function (error) {
            _this.$message.error(error.message);
        });
    };
    Password = __decorate([
        Component
    ], Password);
    return Password;
}(VueDialog));
export default Password;
